import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { onSubmit } from '@/helpers/CartHelpers';
import MobileCartButton from '@/components/elements/MobileCartButton.vue';
import Price from '@/components/elements/Price.vue';
import { closeCartModal } from '@/modals/cartModal';
import PayButton from './PayButton.vue';
@Component({
    components: { MobileCartButton, Price, PayButton },
    computed: mapGetters({
        paymentDueByCreditCard: 'Cart/paymentDueByCreditCard',
    }),
})
export default class CheckoutMobileFooter extends Vue {
    @Prop()
    context;
    @Prop({ default: false })
    submitDisabled;
    @Prop({ default: false })
    submitting;
    @Prop()
    supportedWallet;
    @Prop()
    selectedPaymentType;
    @Prop()
    wallet;
    get hideCartAndTotal() {
        return this.$store.state.Cart.redeemMembership && this.$store.getters['Cart/paymentDueByCreditCard'] === 0;
    }
    onSubmit() {
        closeCartModal();
        onSubmit(this.context, this.$router, () => this.$emit('submit'));
    }
}
